import { render, staticRenderFns } from "./PublicTravelDeclaration.vue?vue&type=template&id=463a0fe2&scoped=true"
import script from "./PublicTravelDeclaration.vue?vue&type=script&lang=js"
export * from "./PublicTravelDeclaration.vue?vue&type=script&lang=js"
import style0 from "./PublicTravelDeclaration.vue?vue&type=style&index=0&id=463a0fe2&prod&scoped=true&lang=css"
import style1 from "./PublicTravelDeclaration.vue?vue&type=style&index=1&id=463a0fe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a0fe2",
  null
  
)

export default component.exports